import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetRatingListAtom } from "../../store/ratingAtom";

function RatingScroll({ viewItemDetails }) {
  const { id } = useParams();
  const ratingAtomData = GetRatingListAtom();

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (ratingAtomData?.rating_info) {
      setItems(ratingAtomData.rating_info);
    }
  }, [ratingAtomData?.rating_info]);

  const statusBadge = (statusId, statusName) => {
    const styles = {
      1: "bg-emerald-100 text-emerald-800 border-emerald-200",
      2: "bg-rose-100 text-rose-800 border-rose-200",
      3: "bg-amber-100 text-amber-800 border-amber-200",
      4: "bg-blue-100 text-blue-800 border-blue-200",
      5: "bg-purple-100 text-purple-800 border-purple-200",
      6: "bg-gray-100 text-gray-700 border-gray-200",
    };

    return (
      <span
        className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${
          styles[statusId] || "bg-gray-100 text-gray-700 border-gray-200"
        }`}
      >
        {statusName || "—"}
      </span>
    );
  };

  return (
    <div className="h-[calc(100vh-140px)] bg-white rounded-xl border shadow-sm overflow-hidden flex flex-col">
      {/* Header */}
      <div className="bg-gray-50 border-b px-4 py-3">
        <h3 className="text-sm font-semibold text-gray-700">
          Rating Types
        </h3>
      </div>

      {/* Scrollable List */}
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-50 hover:scrollbar-thumb-gray-400 transition-colors duration-150">
        {items.length === 0 ? (
          <div className="h-full flex items-center justify-center text-gray-500 text-sm p-6 text-center">
            No rating types available
          </div>
        ) : (
          items.map((rating, index) => {
            const isActive = Number(id) === rating?.Transaction_type_Id;

            return (
              <div
                key={rating.Transaction_type_Id || index}
                onClick={() => viewItemDetails(rating?.Transaction_type_Id)}
                className={`
                  group border-b last:border-b-0 px-4 py-3.5 cursor-pointer transition-colors duration-150
                  hover:bg-indigo-50/50
                  ${isActive ? "bg-indigo-50 border-l-4 border-l-indigo-500" : ""}
                `}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 line-clamp-2">
                      {rating?.Transaction_Type_Name || "Unnamed Type"}
                    </p>

                    <div className="mt-1.5 flex flex-col gap-1 text-xs text-gray-600">
                      <span>
                        Rating: <span className="font-medium text-amber-600">{rating?.Rating_Value || "—"}</span>
                      </span>
                      <span className="mt-1">
                        Total: <span className="font-semibold text-gray-800">{rating?.Total_Rating || 0}</span>
                      </span>
                    </div>

                    {/* Optional status badge – if still needed */}
                    {/* {rating?.Corporate_Approval_Status_Name && (
                      <div className="mt-2">
                        {statusBadge(rating?.Corporate_Approval_Status_Id, rating?.Corporate_Approval_Status_Name)}
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Footer */}
      {items.length > 0 && (
        <div className="px-4 py-2.5 bg-gray-50 border-t text-xs text-gray-500 flex justify-between items-center">
          <span>
            {items.length} {items.length === 1 ? "type" : "types"}
          </span>
          <span className="text-gray-400">Click to view ratings</span>
        </div>
      )}
    </div>
  );
}

export default RatingScroll;